import { puede } from './permisos';

export function accionesDocumento(usuario, empresa, tipo, doc) {
  const editar = puede(usuario, 'presupuestos', 'editar');
  const crear = puede(usuario, 'presupuestos', 'crear');
  const factura = tipo === 'facturas';
  const bloqueado = factura && Boolean(doc.verifactu?.enviado);
  return {
    editar: editar && !bloqueado && !doc.firmaInfo?.firmado && (factura || doc.estado !== 'convertido'),
    clonar: !factura && puede(usuario, 'presupuestos', 'ver') && crear,
    convertir: !factura && editar && doc.estado !== 'convertido',
    eliminar: puede(usuario, 'presupuestos', 'eliminar') && !bloqueado,
    enviar: !bloqueado && (editar || crear || puede(usuario, 'clientes', 'enviar_email') || usuario?.rol === 'admin' || usuario?.rol === 'superadmin'),
    verifactu: factura && editar && !bloqueado,
    pagar: factura && editar && !bloqueado && doc.estado !== 'pagada',
  };
}